import { Component, Input, Output, EventEmitter, AfterViewInit, ViewChild } from "@angular/core";

import { ScriptLoaderService } from '../../_services';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html'
})

export class DatePickerComponent implements AfterViewInit {
    @Input() texts = {
        label: "",
        placeholder: ""
    };
    @Output() dateChanged = new EventEmitter();
    @ViewChild('dateInput') dateInput;
    value: { date: Date, string: string };
    constructor(protected _script: ScriptLoaderService) { }
    ngAfterViewInit() {
        this._script.loadScripts('app-date-picker',
            ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-datepicker.js']);
        ($(this.dateInput.nativeElement) as any).on('changeDate', (ev) => {
            let date: Date = ($(this.dateInput.nativeElement) as any).datepicker("getDate");
            // let string = this.getFormat(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
            let string = ($(this.dateInput.nativeElement) as any).val();
            this.value = { date: date, string: string };
            this.dateChanged.emit(this.value);
        });
    }
    setDate(date) {
        this.value = { date: new Date(date), string: date };
        ($(this.dateInput.nativeElement) as any).datepicker('update', date);
    }
    clear() {
        this.value = null;
        ($(this.dateInput.nativeElement) as any)
            .val("")
            .datepicker({
                todayHighlight: !0,
                format: this.getFormat('yyyy', 'mm', 'dd'),
                orientation: "bottom left",
                templates: {
                    leftArrow: '<i class="la la-angle-left"></i>',
                    rightArrow: '<i class="la la-angle-right"></i>'
                }
            });
    }
    empty() {
        return !this.value;
    }
    getFormat(year, month, day): string {
        return `${year}-${month}-${day}`;
    }

    getNow() {
        let date: Date = ($(this.dateInput.nativeElement) as any).datepicker({ format: this.getFormat('yyyy', 'mm', 'dd'), orientation: "bottom left" }).datepicker("setDate", new Date());
        return date;
    }

    getFirstDayMonth() {
        var dateNow = new Date();
        let date: Date = ($(this.dateInput.nativeElement) as any).datepicker({ format: this.getFormat('yyyy', 'mm', 'dd'), orientation: "bottom left" }).datepicker("setDate", new Date(dateNow.getFullYear(), dateNow.getMonth(), 1));
        return date;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/date-picker/date-picker.component.ts